import { Directive, Input, inject } from '@angular/core';
import { AbstractFinderComponent } from '@df/catalog/abstract-finder/abstract-finder.component';
import { AbstractFinderService } from '@df/catalog/abstract-finder/abstract-finder.service';
import { IStoreData, Store } from '@df/catalog/store/store';
import { StoreService } from '@df/catalog/store/store.service';

@Directive()
export class StoreFinderComponentDef<T extends Store = Store, TData extends IStoreData = IStoreData> extends AbstractFinderComponent<
    T,
    TData
> {
    finderService = inject(StoreService) as any as AbstractFinderService<T, TData>;

    @Input()
    title?: string;

    @Input()
    subtitle?: string;

    /**
     * Google map options
     * Keep in mind that you can set up defaults using app.config.gmap
     * @type {google.maps.MapOptions | undefined}
     */
    @Input()
    googleMapOptions?: google.maps.MapOptions;
}
